import { render, staticRenderFns } from "./AddDiscountCodeBox.vue?vue&type=template&id=250d0936"
import script from "./AddDiscountCodeBox.vue?vue&type=script&lang=ts"
export * from "./AddDiscountCodeBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports